import React from 'react';

import { getModalToShow, Product, type StorageAdapter, UpgradeModalComponent } from '../../utils';
import { ConfluenceStandardOfferAIModal } from '../ConfluenceStandardOfferAIModal';

export const ConfluenceUpgradeFreePoolExperimentModalPreUpgrade = ({
	storageAdapter,
	experienceUrl,
	analyticsAttributes,
}: {
	analyticsAttributes: Record<string, any>;
	experienceUrl: string;
	storageAdapter: StorageAdapter;
}) => {
	// If there is an issue fetching the experience url, do not render the modal
	if (!experienceUrl) {
		return null;
	}

	// Determine which modal to show
	const modalToShow = getModalToShow(storageAdapter, Product.Confluence);

	// Render the appropriate modal component
	switch (modalToShow) {
		case UpgradeModalComponent.ConfluenceStandardOfferAIModalFirstTime:
			return (
				<ConfluenceStandardOfferAIModal
					analyticsAttributes={analyticsAttributes}
					experienceUrl={experienceUrl}
					storageAdapter={storageAdapter}
					nthTimeShown={1}
				/>
			);
		case UpgradeModalComponent.ConfluenceStandardOfferAIModalSecondTime:
			return (
				<ConfluenceStandardOfferAIModal
					analyticsAttributes={analyticsAttributes}
					experienceUrl={experienceUrl}
					storageAdapter={storageAdapter}
					nthTimeShown={2}
				/>
			);
		case UpgradeModalComponent.None:
		default:
			return null;
	}
};
